import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifs-digicod',
  templateUrl: './notifs-digicod.component.html',
  styleUrls: ['./notifs-digicod.component.scss']
})
export class NotifsDigicodComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
